module.exports = __webpack_public_path__ + "img/puzzle-fill.c7479f1d.svg";